/* eslint-disable @nx/enforce-module-boundaries */
import { loan_application } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Button } from '@axo/ui-core/components/Button';
import { Stack } from '@axo/ui-core/components/layout/item';
import { Modal } from '@axo/ui-core/components/Modal';
import { Heading, Text } from '@axo/ui-core/components/typography';
import { useAxoFormContext } from '../../../context/AxoForm/AxoForm';
import { DebtInfo } from './DebtInfo';
import styles from './ESkat.module.scss';
import { ESkatInfo } from './ESkatInfo';
import { useESkat } from './hooks/useESkat';

type ESkatDetailsProps = {
  open: boolean;
  onClose: () => void;
};

export const ESkatDetails = ({ open, onClose }: ESkatDetailsProps) => {
  const { t } = useTranslation();

  const { eSkatData, hasFetchedDebts } = useESkat();

  const { axoFormData } = useAxoFormContext();

  if (!eSkatData?.HasCaseData) {
    return (
      <Modal open={open} onClose={onClose} hasClose>
        <Modal.Header feedbackState="error">
          <Heading size="xs">{t('ESkat.error_modal.title')}</Heading>
          <Text size="s">{t('ESkat.error_modal.no_data')}</Text>
        </Modal.Header>
      </Modal>
    );
  }
  const debts = axoFormData['LoanApplication/Debts'] as loan_application.Debt[];

  const { UpdatedAt } = eSkatData;

  const date = new Date(UpdatedAt).toLocaleDateString('da-DK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
  const time = `${new Date(UpdatedAt).getHours()}:${new Date(
    UpdatedAt
  ).getMinutes()}`;

  return (
    <Modal open={open} onClose={onClose} hasClose>
      <Modal.Header feedbackState="success">
        <Heading size="xs">{t('ESkat.success_modal.title')}</Heading>

        <Text size="s">
          {t('ESkat.success_modal.date', {
            date,
            time,
          })}
        </Text>
      </Modal.Header>

      <Stack className={styles.inputBackground}>
        <ESkatInfo kind="loan" />

        <ESkatInfo kind="person" />

        {hasFetchedDebts && debts && (
          <Stack gap="3xs">
            <Text size="l">
              <b>{t('ESkat.success_modal.title_debts')}</b>
            </Text>
            {debts.map((field, index) => (
              <DebtInfo key={index} debt={field as loan_application.Debt} />
            ))}
          </Stack>
        )}
      </Stack>

      <Modal.Actions>
        <Button size="small" variant="tertiary" onClick={onClose}>
          {t('close')}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
